<template>
    <div class="form">
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
            <v-layout>
                <v-flex xs12>
                    <v-layout row>
                        <v-flex md12>
                            <div class="content-wrapper">
                                <div class="info-block">
                                    {{ isEditMode ? 'Edit device' : 'Add vehicle device'}}
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout row v-if="errors !== null">
                        <v-flex md12>
                            <div class="content-wrapper">
                                <div class="error-block">
                                    <div class="title">Errors</div>
                                    <p v-html="errors"></p>
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout row justify-space-around>
                        <v-flex md6>
                            <div class="content-wrapper">
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Recorder ID <span class="required">*</span></span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-text-field
                                            label="Insert recorder ID"
                                            v-model="form.hardwareId"
                                            :rules="rules.hardwareId"
                                            required
                                            outline
                                            single-line
                                            :disabled="isEditMode"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Device Model <span class="required">*</span></span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-select
                                            v-model="form.deviceModelId"
                                            :items="getDeviceModels"
                                            :rules="rules.deviceModelId"
                                            label="Select a device model"
                                            item-text="key"
                                            item-value="id"
                                            outline
                                            single-line
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Channels <span v-if="availableChannels && availableChannels.length" class="required">*</span></span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-select
                                            v-model="form.channels"
                                            :items="availableChannels"
                                            :rules="rules.channels"
                                            label="Select channel number"
                                            item-text="key"
                                            item-value="id"
                                            multiple
                                            required
                                            outline
                                            single-line
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Device Protocol <span class="required">*</span></span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-select
                                            v-model="form.deviceProtocolId"
                                            :items="getDeviceProtocols"
                                            :rules="rules.deviceProtocolId"
                                            label="Select a device protocol"
                                            item-text="key"
                                            item-value="id"
                                            outline
                                            single-line
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Data to capture <span class="required">*</span></span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-select
                                            v-model="form.dataToCapture"
                                            :items="getDeviceDataToCapture"
                                            :rules="rules.dataToCapture"
                                            label="Select a data to capture"
                                            item-text="key"
                                            item-value="id"
                                            required
                                            outline
                                            single-line
                                            :multiple="true"
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Enabled</span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-checkbox
                                            v-model="form.enabled"
                                        ></v-checkbox>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Customer SIM</span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-checkbox
                                            v-model="form.customerSim"
                                        ></v-checkbox>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Automatic Video Download</span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-checkbox
                                            v-model="form.automaticVideoDownload"
                                        ></v-checkbox>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </v-flex>
                        <v-flex md6>
                            <div class="content-wrapper">
                                <v-layout v-if="!isEditMode" row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Organization name</span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <organization-autocomplete
                                            class="organization-autocomplete"
                                            v-model="form.organization"
                                            :disabled="!(!form.fleet && !form.vehicle)"
                                        ></organization-autocomplete>
                                    </v-flex>
                                </v-layout>
                                <v-layout v-if="!isEditMode" row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Fleet name</span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <fleet-autocomplete
                                            v-model="form.fleet"
                                            :organization="form.organization"
                                            :disabled="!(!!form.organization && !form.vehicle)"
                                        ></fleet-autocomplete>
                                    </v-flex>
                                </v-layout>
                                <v-layout v-if="!isEditMode" row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Vehicle</span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <vehicle-autocomplete
                                            v-model="form.vehicle"
                                            :fleet="form.fleet"
                                            :disabled="!(!!form.fleet && !!form.organization)"
                                        ></vehicle-autocomplete>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">SIM Number</span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-text-field
                                            label="Insert SIM number"
                                            v-model="form.simNumber"
                                            :rules="rules.simNumber"
                                            outline
                                            single-line
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Serial Number</span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-text-field
                                            label="Insert Serial Number"
                                            v-model="form.serialNumber"
                                            :rules="rules.serialNumber"
                                            outline
                                            single-line
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4>
                                        <div class="label text-xs-right">
                                            <span class="text-xs-right">Firmware Version</span>
                                        </div>
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-text-field
                                            label="Insert Firmware Version"
                                            v-model="form.firmwareVersion"
                                            :rules="rules.firmwareVersion"
                                            outline
                                            single-line
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-layout row class="buttons">
                <v-flex xs6>
                    <sp-button @click.native="goBack" text="Go Back" small-icon icon="go-back" sp-class="go-back"></sp-button>
                </v-flex>
                <v-flex xs6 class="right text-xs-right">
                    <div class="content-wrapper">
                        <sp-button @click.native="validate" text="Save" icon="download"></sp-button>
                    </div>
                </v-flex>
            </v-layout>
        </v-form>
    </div>
</template>

<script>
import SpButton from '@/components/forms/Button'
import router from '@/router/routes'
import { mapGetters } from 'vuex'
import { bitFlagToArray } from '@/helpers/Utils'
import OrganizationApi from '@/api/OrganizationApi'
import OrganizationAutocomplete from '@/views/Organizations/components/OrganizationAutocomplete'
import FleetAutocomplete from '@/views/Fleets/components/FleetAutocomplete'
import VehicleAutocomplete from '@/views/Vehicles/components/VehicleAutocomplete'

const organizationApi = new OrganizationApi()

export default {
    name: 'DeviceForm',
    components: {
        VehicleAutocomplete,
        FleetAutocomplete,
        OrganizationAutocomplete,
        SpButton
    },
    props: {
        handler: {
            type: Function,
            required: true
        },
        form: {
            type: Object,
            required: true
        },
        isEditMode: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            valid: false,
            errors: null,
            rules: {
                hardwareId: [
                    v => (4 <= (v || '').trim().length && 50 >= (v || '').trim().length) || 'Recorder Id must be at least 4 and less than 50 characters',
                    v => (v === (v || '').trim()) || 'Recorder Id cannot have leading or trailing spaces'
                ],
                firmwareVersion: [
                    v => (50 >= (v || '').trim().length) || 'Firmware version must be less than 50 characters',
                    v => (v === (v || '').trim() || null === v) || 'Firmware version cannot have leading or trailing spaces',
                    v => (3 <= (v || '').trim().length || 0 === (v || '').trim().length) || 'Firmware version can be empty or must be greater than 3 characters'
                ],
                simNumber: [
                    v => (50 >= (v || '').trim().length) || 'SIM number must be less than 50 characters',
                    v => (v === (v || '').trim() || null === v) || 'SIM number cannot have leading or trailing spaces',
                    v => (3 <= (v || '').trim().length || 0 === (v || '').trim().length) || 'SIM number can be empty or must be greater than 3 characters'
                ],
                serialNumber: [
                    v => (50 >= (v || '').trim().length) || 'Serial number must be less than 50 characters',
                    v => (v === (v || '').trim() || null === v) || 'Serial number cannot have leading or trailing spaces',
                    v => (3 <= (v || '').trim().length || 0 === (v || '').trim().length) || 'Serial number can be empty or must be greater than 3 characters'
                ],
                deviceModelId: [
                    v => !!v || 'Device model is required'
                ],
                deviceProtocolId: [
                    v => !!v || 'Device protocol is required'
                ],
                channels: [
                    v => 0 <= v.length || 'Channel is required'
                ],
                dataToCapture: [
                    v => 0 !== v.length || 'Data to capture is required'
                ]
            }
        }
    },
    mounted () {
        if (this.hasAllRoles(['OrganizationView'])) {
            this.getOrganization()
        }
        this.form.dataToCapture = this.getDeviceDataToCapture.map(el => el.id)
    },
    computed: {
        ...mapGetters('dictionaryModule', [
            'getDeviceModels',
            'getDeviceDataToCapture',
            'getDeviceProtocols',
            'getChannels'
        ]),
        ...mapGetters('authModule', [
            'getActiveOrganization'
        ]),
        availableChannels () {
            if (this.form.deviceModelId) {
                const currentDeviceModel = this.getDeviceModels.filter(model => {
                    return model.id === this.form.deviceModelId
                })[0]
                const deviceModelChannels = bitFlagToArray(currentDeviceModel ? currentDeviceModel.availableChannels : 0)

                const channelOptions = this.getChannels.filter(channel => deviceModelChannels.includes(channel.id))

                    if (channelOptions.length) this.rules.channels = [ v => 1 <= v.length || 'Channel is required' ]
                    else this.rules.channels = [ v => 0 <= v.length || 'Channel is required' ]

                return channelOptions
            } else {
                this.rules.channels = [ v => 1 <= v.length || 'Channel is required' ]
                return []
            }
        }
    },
    watch: {
        'form.deviceModelId': function (newVal, oldVal) {
            if ((this.isEditMode && oldVal) || !this.isEditMode) {
                this.form.channels = this.availableChannels.map(channel => channel.id)
            }
        },
        'form.fleet': function (newVal, oldVal) {
            this.form.vehicle = null
        }
    },
    methods: {
        async validate () {
            this.valid = this.$refs.form.validate()
            if (!this.valid) {
                return false
            }

            try {
                this.errors = null
                await this.handler(this.form)
            } catch (e) {
                this.errors = e.message
            }
        },
        async getOrganization () {
            if (this.isEditMode) return
            const response = await organizationApi.getOrganizationById(this.getActiveOrganization)
            if (!response.isSuccess) return
            this.form.organization = response.payload
        },
        goBack () {
            router.back()
        }
    }
}
</script>

<style scoped>
    .organization-autocomplete {
        margin-bottom: 28px;
    }
</style>
